import {useEffect, ChangeEvent, useState} from "react";
import React from "react";
import styles from "./StatementPage.module.scss";
import arrow from "../../styles/images/nextButton.svg";
// import Spinner from 'react-bootstrap';
import useTokenARBalance from "../../hooks/useTokenARBalance";
import analyticsService from '../../services/analytics/analyticsService';
import {format} from "date-fns";
import useProfileLinks from "../../hooks/useProfileLinks";
import {useLocation} from "react-router-dom";
import addCommas from "../../util/add-commas";

declare global {
    interface Window {
      _satellite: any;
    }
  }
  
  window._satellite = window._satellite || {};

const StatementPage = () =>{
    document.title = "Scholastic Account Balance";
    let dumble = new analyticsService();

    const [isLoading, setIsLoading] = useState(true);
    const [totalPages, setTotalPages] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 20;
    const [transactionList, setTransactionList] = useState<any[]>([]);
    const [agingDetails, setAgingDetails] = useState<any>({});
    const [accountNumber, setAccountNumber] = useState(0);
    const [statementType, setStatementType] = useState("");
    const [billTo, setBillTo] = useState<any>({});
    const [errorMessage, setErrorMessage] = useState('');
    const tokenARBalance = useTokenARBalance();
    const searchParam = useLocation().search;
    const token = new URLSearchParams(searchParam).get('token');

    const formatDate = (dateValue: string, dateFormat: string) => {
        if (dateValue === "today"){
            const dt = new Date();
            return(format(dt, dateFormat));
        } else if (dateValue === null || dateValue === undefined) {
            return("N/A");
        } else  {
            dateValue = dateValue.replaceAll('-', '/');
            const dt = new Date(dateValue);
            return (format(dt, dateFormat));
        }
    }

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
    };

    const fetchTokenARResults = async () => {
        const {data, error} = await tokenARBalance(token);

        if (error) {
            dumble.setStatementPageError(true);
            setErrorMessage(error.data.error);
            setIsLoading(false);
            console.log(errorMessage);
        } else {
            dumble.setStatementPageError(false);
            setAccountNumber(data.data.accountNumber)
            setTransactionList(data.data.items);
            setAgingDetails(data.data.agingDetails);
            setBillTo(data.data.billTo);
            setTotalPages(Math.ceil(data.data.items.length/rowsPerPage));
            if (data.data.statementType === null) {
                setStatementType("N/A");
            } else {
                setStatementType(data.data.statementType);
            }
            setIsLoading(false);
        }
    }

    const startIndex = (currentPage - 1) * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    const currentRows = transactionList.slice(startIndex, endIndex);

    useEffect(() => {
        if (token){
            fetchTokenARResults();
        }
    }, [token]);

    const billToString = () => {
        if (billTo === null){
            return (
                <div className={styles.address}>
                    N/A
                </div>)
        }
        else{
            return (
                <div className={styles.address}>
                    <div>{billTo.billToName}</div>
                    <div>{billTo.billToAddressLine1}</div>
                    <div>{billTo.billToAddressLine2}</div>
                    <div>{billTo.billToCity + ", " + billTo.billToState + " " + billTo.billToZipCode}</div>
                </div>
            )
        }
    }

    return(
        <div className={styles.StatementPage}>
            <div className={styles.title}>Account Balance</div>
            {
                !isLoading ?
                <>
                    <div className={styles.topContainer}>
                        <div className={styles.tableContainer1}>
                            <table>
                                <tbody>
                                    <tr className={styles.rowTop}>
                                        <th >
                                            <div className={styles.value}>
                                                Date
                                            </div>
                                        </th>
                                        <td>
                                            <div className={styles.valueAmount}>
                                                <div className={styles.amount}>
                                                    {formatDate("today", 'MM/dd/yy')}
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr className={styles.rowMid}>
                                        <th>
                                            <div className={styles.value}>Past Due Amount</div>
                                            <div className={styles.value}>Current Amount</div>
                                        </th>
                                        <td>
                                            <div className={styles.valueAmount}>
                                                <div className={styles.dollerSymbol}>$</div>
                                                <div className={styles.amount}>{addCommas(agingDetails.pastDueBalance )}</div>
                                            </div>
                                            <div className={styles.valueAmount}>
                                                <div className={styles.dollerSymbol}>$</div>
                                                <div className={styles.amount}>{addCommas(agingDetails.currentBalance )}</div>
                                            </div>
                                        </td>
                                    </tr>

                                    <tr className={styles.rowEnd}>
                                        <th >
                                            <div className={styles.value}>
                                            Total Balance Due
                                            </div>
                                        </th>
                                        <td>
                                            <div className={styles.valueAmount}>
                                                <div className={styles.dollerSymbol}>$</div>
                                                <div className={styles.amount}>{addCommas(agingDetails.totalBalance )}</div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className={styles.section2}>
                                <div className={styles.innerContainer1}>
                                    <div className={styles.accountNoSection}>
                                        <div className={styles.accountNumber}>Account Number</div>
                                        <div className={styles.number}>{accountNumber}</div>
                                    </div>
                                    <div className={styles.billTo}>
                                        Bill to:
                                        {billToString()}
                                    </div>
                                </div>
                            <div className={styles.innerContainer2}>
                                <div className={styles.line1}>Please make checks or money orders payable to:</div>
                                {statementType === "EDUCATION" &&
                                    <div className={styles.line2}>
                                        <div>Scholastic Inc. (Education, Library Publishing, and Weston Woods)</div>
                                        <div>PO Box: 639852</div>
                                        <div>Cincinnati, OH 45263-9852</div>
                                    </div>
                                }
                                {statementType === "TRADE" &&
                                    <div className={styles.line2}>
                                        <div>Scholastic Inc.</div>
                                        <div>PO Box: 639851</div>
                                        <div>Cincinnati, OH 45263-9851</div>
                                </div>
                                }
                                {statementType === "N/A" &&
                                    <div className={styles.line2}>
                                        N/A
                                    </div>
                                }
                                <div className={styles.line3}>Questions? Contact us at {" "}
                                {statementType === "TRADE" ? "1-888-724-1872" : "1-800-225-1761"}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={styles.tableContainer2}>
                        <table className={styles.table} >
                            <thead className={styles.tableHead}>
                                <tr>
                                    <th>Transaction <br/> Date</th>
                                    <th>Transaction <br/> No.</th>
                                    <th>Due <br/> Date</th>
                                    <th>Transaction <br/> Type</th>
                                    <th>PO NO/CM <br/> Refer No.</th>
                                    <th className= {styles.accountBalance}>Amount</th>
                                    <th className= {`${styles.balance} ${styles.accountBalance}`}>Balance</th>
                                </tr>
                            </thead>
                            <tbody className={styles.mainTableBody}>
                                {currentRows.map((item, index) => (
                                    <React.Fragment key={index}>
                                        <tr className={styles.mainTableRow}>
                                            <td>{formatDate(item.transactionDate, 'MM/dd/yyyy')}</td>
                                            <td className={styles.transactionNo}>
                                                {item.invoicePdfUrl && item.transactionType.toUpperCase() === "INVOICE" ? (
                                                    <a
                                                        href={item.invoicePdfUrl}
                                                        target="_blank"
                                                        rel="noopener"
                                                        onClick={ () => {
                                                            console.log("satellite track transaction number click");
                                                            window._satellite.track('transaction-number-click');
                                                        }}
                                                    >
                                                        {item.transactionNumber}
                                                    </a>
                                                ) : (
                                                    <span>{item.transactionNumber}</span>
                                                )}
                                            </td>
                                            <td>{formatDate(item.dueDate, 'MM/dd/yyyy')}</td>
                                            <td>{item.transactionType}</td>
                                            <td>{item.poNum}</td>
                                            <td className={styles.accountBalance}>{addCommas(item.amount )}</td>
                                            <td className={`${styles.balance} ${styles.accountBalance}`}>{addCommas(item.balance )}</td>
                                        </tr>
                                    </React.Fragment>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className={styles.paginationContainer}>
                        <div className={styles.pagination}>
                            <button className={styles.previousButton} onClick={() => {if(currentPage !== 1){handlePageChange(currentPage - 1)}}}>
                                <img src={arrow}  alt="" style={{opacity: currentPage ===1? '25%': '100%'}} />
                            </button>
                            <div className={styles.pageCount}>
                                <div>Page</div> 
                                <div className={styles.currentPage}>
                                    <div className={styles.number}>
                                        {currentPage}
                                    </div>
                                </div> 
                                <div>of </div>
                                <div className={styles.currentPage}>
                                    <div className={styles.totalNumber}>
                                        {totalPages}
                                    </div>
                                </div> 
                            </div>
                            <button className={styles.nextButton} onClick={() => {if(currentPage < totalPages){handlePageChange(currentPage + 1)}}}>
                                <img src={arrow}  alt="" style={{opacity: currentPage === totalPages? '25%': '100%'}}  />
                            </button>
                        </div>
                    </div>
                    <div className={styles.container3}>
                        {statementType === "TRADE" 
                            ?
                            <div className={styles.innerContent}>
                                Thank you for ordering from Scholastic. Please note our terms as shown on your invoice. For billing problems, call 1-888-724-1872. Thank you!                    
                            </div>
                            :
                            <div className={styles.innerContent}>
                                Our terms are 30 days. If you have any questions regarding your bill, please contact Scholastic at 1-800-225-1761. Thank you.
                            </div>
                        }
                        <div className={`${styles.innerContent} ${styles.invoiceContent}`}>
                            Please note, links to invoices are accessible for 1 year.
                        </div>
                    </div>
                    {statementType === "TRADE" && <div className={styles.pastDueHeadContainer}>
                        <div className={styles.pastDueHead}> 
                            <div>
                                Past Due Amounts
                            </div>
                        </div>
                    </div>}
                    <div className={styles.container4}>
                    
                        <table>
                            <thead>
                                <th>Current</th>
                                <th>1-30 <br/>Days</th>
                                <th>31-60 <br/> Days</th>
                                <th>61-90 <br/> Days</th>
                                <th>Over 90 <br/> Days</th>
                                <th>Balance</th>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>${agingDetails.currentBalance && addCommas(agingDetails.currentBalance )}</td>
                                    <td>${agingDetails.last30Days && addCommas(agingDetails.last30Days )}</td>
                                    <td>${agingDetails.between30to60days && addCommas(agingDetails.between30to60days )}</td>
                                    <td>${agingDetails.between60to90days && addCommas(agingDetails.between60to90days )}</td>
                                    <td>${agingDetails.over90days&& addCommas(agingDetails.over90days )}</td>
                                    <td>${agingDetails.totalBalance && addCommas(agingDetails.totalBalance )}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </>
                :
                <div className={styles.spinnerDiv}>
                    <div className={styles.spinner}/>
                </div>
            }
        </div>

    )
}
  export default StatementPage;